import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { ListGroup } from 'react-bootstrap'
import Article from '@components/article/Article'
import Heading from '@components/heading/Heading'
import ArticleBody from '@components/article/ArticleBody'

const Promotion = (): React.JSX.Element => {
  const data = useStaticQuery(graphql`
    query getContents {
      afbResources {
        items {
          promotion {
            adv_name
            unique_adv_id
          }
        }
      }
    }
  `)

  const promotion: Array<any> = data?.afbResources?.items?.promotion.slice(0, 3)

  return (
    <>
      {/* memo: 旧ページに飛ばしている状態 */}
      <Article type="main" className="indexArticleWrap">
        <Heading tagName="h2">新着プロモーション</Heading>
        <ArticleBody className="indexPromotion__list">
          <ListGroup as="ul" variant="flush">
            {promotion.map((item: any, index: number) => (
              <ListGroup.Item
                as="li"
                key={`promo${index}`}
                className="indexPromotion__listItem"
              >
                <a href={`/general/partner/relation?s=${item.unique_adv_id}`}>
                  {item.adv_name}
                </a>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </ArticleBody>
      </Article>
    </>
  )
}

export default Promotion
